import type { SecondFactorMethod } from '../model/types';

export const otpDigits = (value: string): string => value.replace(/\D/g, '');

/** TOTP and email codes submit themselves at 6 digits. Backup codes stay manual. */
export const shouldAutoSubmitOtp = (method: SecondFactorMethod | string, value: string): boolean =>
  method !== 'backup' && otpDigits(value).length === 6;
